import { Modal, Box, Tooltip, IconButton } from "@mui/material"
import { Image } from "primereact/image";
import { FC } from "react"
import pool from "../../../../assets/images/pool-de-risco/pool-de-risco.jpg";
import { RiCloseLargeFill } from "react-icons/ri";

const ModalPoolRisco: FC<{
    open: boolean, 
    setOpen(value: boolean): void, 
}> = ({open, setOpen}) => {

    const handleClose = () => setOpen(false);

    return <Modal
    open={open}
    onClose={handleClose}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
>
<Box sx={{ maxHeight: "100vh", overflowY: "auto", maxWidth: "80vmax", margin: "0 auto", position: "relative"}}>
    <Tooltip title="Fechar" sx={{ position: "absolute", right: 0, top: 0}}>
        <IconButton onClick={handleClose   
        }>
            <RiCloseLargeFill />
        </IconButton>
    </Tooltip>
<Image width="100%" src={pool}/>
</Box>

</Modal>
}

export default ModalPoolRisco;